export function parseMoneySort(value: string): number {
  const n = parseFloat(String(value).replace(/[^\d.-]/g, ''))
  return Number.isFinite(n) ? n : 0
}
